import type * as React from "react";
import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import type { IWebsiteListTypeSelectorProps } from "pro-features/components/WebsiteListTypeSelector/src/WebsiteListTypeSelector";
import { WebsiteListTypeSelector } from "pro-features/components/WebsiteListTypeSelector/src/WebsiteListTypeSelector";

const WebsiteListTypeSelectorContainerWrapper = styled.div`
    border: 1px solid ${colorsPalettes.carbon["50"]};
`;

export const WebsiteListTypeSelectorContainer: React.FC<IWebsiteListTypeSelectorProps> = ({
    onListTypeSelect,
    selectedListType,
    disabled,
}) => {
    const selector = (
        <WebsiteListTypeSelectorContainerWrapper>
            <WebsiteListTypeSelector
                disabled={disabled}
                selectedListType={selectedListType}
                onListTypeSelect={onListTypeSelect}
                containerClass="WebsiteListTypeSelector"
            />
        </WebsiteListTypeSelectorContainerWrapper>
    );

    return selector;
};
